import styled from '@emotion/styled';

const StyledSitesContainer = styled.div``;

export default StyledSitesContainer;
